import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * `<PossessionFactorStep />` — patient enters verification code
 * from their registered possession factor (phone / hardware token
 * / device-bound credential per PFO §2.2).
 *
 * SCAFFOLD: v0 accepts a non-empty code string + delegates to the
 * orchestrator's `verifyPossessionFactor` callback (production
 * wiring connects to SMS / TOTP / WebAuthn).
 */
import * as React from 'react';
import { useLocale } from '../../i18n/locale-context.js';
export function PossessionFactorStep(props) {
    const { t } = useLocale();
    const [code, setCode] = React.useState('');
    const handleSubmit = (e) => {
        e.preventDefault();
        if (code.length === 0) {
            return;
        }
        props.onSubmit(code);
        setCode('');
    };
    return (_jsxs("section", { "aria-labelledby": "possession-heading", children: [_jsx("h3", { id: "possession-heading", children: t('authentication.possession_factor.heading') }), _jsx("p", { children: t('authentication.possession_factor.body') }), _jsxs("form", { onSubmit: handleSubmit, children: [_jsxs("label", { children: [t('authentication.possession_factor.code_label'), _jsx("input", { type: "text", value: code, onChange: (e) => setCode(e.target.value), autoComplete: "one-time-code", inputMode: "numeric", required: true })] }), _jsxs("div", { role: "group", "aria-label": t('authentication.possession_factor.actions_aria_label'), children: [_jsx("button", { type: "submit", disabled: code.length === 0, children: t('authentication.possession_factor.submit') }), _jsx("button", { type: "button", onClick: props.onCancel, children: t('authentication.possession_factor.cancel') })] })] })] }));
}
//# sourceMappingURL=possession-factor-step.js.map